import React, { useState, useEffect } from "react";

const TimerLeft = () => {
  const [timeLeft, setTimeLeft] = useState(50); // Start from 50 seconds

  useEffect(() => {
    if (timeLeft === 0) return; // Stop when timer reaches 0

    const timer = setTimeout(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer); // Cleanup
  }, [timeLeft]);

  const handleSubmit = () => {
    alert("Submitted after timer completed!");
  };

  return (
    <div style={{ marginTop: "40px" }}>
      <h1>{timeLeft > 0 ? `Time Left: ${timeLeft}s` : "Time's up!"}</h1>

      <button 
        onClick={handleSubmit}
        disabled={timeLeft > 0}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          backgroundColor: timeLeft > 0 ? "#ccc" : "#4caf50",
          color: timeLeft > 0 ? "#666" : "white",
          cursor: timeLeft > 0 ? "not-allowed" : "pointer",
          border: "none",
          borderRadius: "4px"
        }}
      >
        Submit
      </button>
    </div>
  );
};

export default TimerLeft;
